import {SystemReportCollection} from './SystemReportCollection';
import {SystemReportField} from './SystemReportField';
import {Screen} from '../../Common/stores/Screen';

export class SystemReportScreen extends Screen {
    lastCopy;

    constructor(screen, name) {
        super(screen, name);
        this.collection = new SystemReportCollection(null);
    }

    setCollection(data) {
        this.collection.insertFields(this, data.fields);
    }

    createNewField(field, parentField) {
        return new SystemReportField(field, parentField);
    }
}
